import React, { useContext, useState, useEffect } from 'react';
import ButtonGroup from '@visa/vds/button-group';
import ButtonText from '@visa/vds/button-text';
import Typography from '@visa/vds/typography'
import Grid from '@visa/vds/grid';
import Row from '@visa/vds/row';
import Col from '@visa/vds/col';
import Select from '@visa/vds/select';
import { PageHelper } from '../../../../_helpers/PageHelper';
import { adminService } from '../../../../services/admin.service';
import { userService } from '../../../../services/user.service';
import { GlobalAlertContext } from '../../../../context/GlobalAlertContext';
import { SubscriptionApi } from 'services/subscription.service';
import FaqB from './FaqB';

function FaqBPage() {
    return (
        <GlobalAlertContext.Consumer>
            {
                alertObj => (
                    <>
                        <Grid>
                            <Row>                                
                                <FaqB/>
                            </Row>
                        </Grid>
                    </>
                )
            }
        </GlobalAlertContext.Consumer> 
    );

}

export default FaqBPage;